export const motion = {
  duration: {
    instant: '80ms',
    fast: '120ms',
    base: '180ms',
    slow: '260ms',
    slower: '400ms',
  },
  ease: {
    standard: 'cubic-bezier(0.2, 0, 0, 1)',
    emphasized: 'cubic-bezier(0.3, 0, 0, 1)',
    overshoot: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
    linear: 'linear',
  },
} as const;

export type MotionTokens = typeof motion;
